import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

export type MenuElement = FlexElement;

export interface MenuProps extends FlexProps {}

export const Menu = styled(Flex).withConfig({
  displayName: 'Menu',
})`
  justify-content: space-between;
`;
